/* eslint-disable max-len */
/* jscs:disable maximumLineLength */

export const ws = process.env.WS || __DEV__ ? 'http://127.0.0.1:3000/' : 'https://stats.nkdev.info/';
